import { render, staticRenderFns } from "./newClt.vue?vue&type=template&id=2936a006&scoped=true"
import script from "./newClt.vue?vue&type=script&lang=js"
export * from "./newClt.vue?vue&type=script&lang=js"
import style0 from "./newClt.vue?vue&type=style&index=0&id=2936a006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2936a006",
  null
  
)

export default component.exports